module.exports = __webpack_public_path__ + "static/media/06-hotspot.5394271d.png";